module.exports = __webpack_public_path__ + "img/Eduzz-10-pt.28405959.png";